var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkGreyLeftArrow = function SvgCkGreyLeftArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.5625,
    r: 24,
    fill: "#05141F",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 23.8958H21.22L24.9466 20.1691L24 19.2291L18.6666 24.5625L24 29.8958L24.94 28.9558L21.22 25.2291H29.3333V23.8958Z",
    fill: "white"
  })));
};
export { SvgCkGreyLeftArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNC41NjI1IiByPSIyNCIgZmlsbD0iIzA1MTQxRiIgZmlsbC1vcGFjaXR5PSIwLjQiLz4KPHBhdGggZD0iTTI5LjMzMzMgMjMuODk1OEgyMS4yMkwyNC45NDY2IDIwLjE2OTFMMjQgMTkuMjI5MUwxOC42NjY2IDI0LjU2MjVMMjQgMjkuODk1OEwyNC45NCAyOC45NTU4TDIxLjIyIDI1LjIyOTFIMjkuMzMzM1YyMy44OTU4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";